import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import './HelpCategoryPage.css';

/**
 * Withdraw from a group Article Page
 */
const WithdrawGroup = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Withdraw from a group</h1>
                <p className="article-subtitle">
                  Learn how to move funds out of a shared group wallet, either by transferring funds immediately or submitting a withdrawal request, depending on your permissions.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Overview</h2>
                  <p className="article-section-intro">
                    WeSplit allows you to withdraw funds from a group to reimburse yourself for expenses or cash out your share of the remaining budget. The process varies based on your assigned permissions.
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Getting Started</h2>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      Open the Group you wish to withdraw from.
                    </li>
                    <li>
                      Tap on the "Withdraw" button on the main dashboard.
                    </li>
                  </ol>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">If You Have Withdraw Permissions</h2>
                  <p className="article-section-intro">
                    If you have been granted the "Withdraw" right (typically Owners and Admins), you can move funds immediately.
                  </p>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Select Destination:</strong>
                      <ul className="article-list-dots">
                        <li>
                          <strong>Personal WeSplit Wallet:</strong> Move money instantly to your own account within the app.
                        </li>
                        <li>
                          <strong>Linked External Wallet:</strong> Send funds directly to an external Solana wallet connected to your account.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Enter Amount:</strong> Input the amount of USDC to withdraw.
                    </li>
                    <li>
                      <strong>Confirm:</strong> Review the details and confirm the transaction. The funds are transferred immediately.
                    </li>
                  </ol>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">If You Do Not Have Permissions</h2>
                  <p className="article-section-intro">
                    If you are a standard member without specific withdraw rights, you will need to request funds from an administrator.
                  </p>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Enter Request Amount:</strong> Input the amount you wish to receive.
                    </li>
                    <li>
                      <strong>Submit Request:</strong> Tap to send the request.
                    </li>
                    <li>
                      <strong>Admin Approval:</strong>
                      <ul className="article-list-dots">
                        <li>
                          The Group Owner and Admins will receive a notification of your request.
                        </li>
                        <li>
                          Once reviewed, an Admin can approve the transaction and transfer the requested funds directly to your Personal WeSplit Wallet.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Top up your group',
                  route: getHelpRoute(getHelpArticleRoute('getting-started', 'top-up-group'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default WithdrawGroup;
